<h1 mat-dialog-title class="text-center !mb-0 !text-[2.2rem] text-darkGray">{{ title }}</h1>
<mat-divider class="!my-3"></mat-divider>
<mat-dialog-content>
  <ng-container *ngIf="data.template; else textMessage">
    <ng-container *ngTemplateOutlet="data.template"></ng-container>
  </ng-container>

  <ng-template #textMessage>
    <p class="!text-sub !text-darkGray whitespace-pre-line text-center">
      {{ confirmMessage }}
    </p>
  </ng-template>
</mat-dialog-content>

<mat-dialog-actions align="center">
  <button type="button"
          [mat-dialog-close]="ConfirmDialogAction.Confirm"
          mat-raised-button
          class="w-48"
          color="primary">{{ confirmBtnTxt }}
  </button>
  <button mat-button
          class="bg-grey-800 text-white w-48"
          [mat-dialog-close]="ConfirmDialogAction.Cancel">
    {{ cancelBtnTxt }}
  </button>
</mat-dialog-actions>
